<template>
  <div class="app-container withdraw">
    <div class="header">
      时间段
      <el-date-picker
        v-model="listQuery.start_date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择开始时间"
      ></el-date-picker>至
      <el-date-picker
        v-model="listQuery.end_date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择结束时间"
      ></el-date-picker>昵称
      <el-input
        v-model="listQuery.nickname"
        placeholder="昵称"
        :clearable="true"
        style="width: 200px;margin: 0px 10px;"
      ></el-input>id
      <el-input
        v-model="listQuery.id"
        placeholder="id"
        :clearable="true"
        style="width: 200px;margin: 0px 10px;"
      ></el-input>
      <el-button size="small" type="primary" style="margin-left: 15px;" @click="search">搜索</el-button>
    </div>
    <div class="fenxiao">￥充值总金额: {{rechargeMoney}}</div>

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>
      <el-table-column label="头像" align="center" min-width="150">
        <template slot-scope="scope">
          <img
            v-if="scope.row.user.avatar"
            :src="scope.row.user.avatar"
            alt
            style="width: 40px;
  height: 40px;"
          />
        </template>
      </el-table-column>
      <el-table-column label="昵称" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.user.nickname}}</template>
      </el-table-column>

      <el-table-column label="联系电话" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.user.phone}}</template>
      </el-table-column>
      <el-table-column label="用户id" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.user.id}}</template>
      </el-table-column>
      <el-table-column label="充值金额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.money}}</template>
      </el-table-column>
      <el-table-column label="充值后余额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.after_balance}}</template>
      </el-table-column>
      <el-table-column label="时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.created_at}}</template>
      </el-table-column>

      <!-- <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="handlePass(scope.row.id)"
            v-if="scope.row.status == 1"
          >处理</el-button>
          <el-button size="small" type="success" @click="handleWatch(scope.row)" v-if="scope.row.status == 2">查看</el-button>
        </template>
      </el-table-column>-->
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10,20,30,50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        start_date: "",
        end_date: "",
        nickname: "",
        id: ""
      },
      list: [],
      rechargeMoney: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/user/rechargeRecord",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.rechargeMoney = result.data.rechargeMoney;
          this.listLoading = false;
        })
        .catch(err => {})
        .finally(err => {});
    },
    handlePass(val) {
      this.$confirm("此操作将提现通过, 是否继续?", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/cashout/agree",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleWatch(row) {
      this.$router.push("/finance/cashout?id=" + row.id + "&type=watch");
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    }
  }
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
</style>
